<template>
    <div class="ac-read-more">
        <Transition name="ac-read-more">
            <div :data-readmore="true" :aria-expanded="readMoreOpen" v-html="text"></div>
        </Transition>
        <button :class="buttonClass" @click="toggle" v-html="toggleString"></button>
    </div>
</template>

<script>

export default {
    name: "ReadMore",
    props: {
        text: {
            type: String,
            required: true
        },
        morePrompt: {
            default: 'Read More',
            type: String
        },
        lessPrompt: {
            default: 'Read Less',
            type: String
        },
        promptClass: {
            default: '',
            type: String,
        }
    },
    data() {
        return {
            readMoreOpen: false,
        }
    },
    computed: {
        toggleString() {
            return (!this.readMoreOpen) ? this.morePrompt : this.lessPrompt;
        },
        buttonClass() {
            return this.promptClass + ' ' + (this.readMoreOpen ? 'open' : 'closed');
        }
    },
    methods: {
        toggle() {
            this.readMoreOpen = !this.readMoreOpen;
        },
    }
}

</script>
